<template>
  <div class="featured-translators">
    <h2>Öne Çıkarılan Tercümanlar</h2>
    <p class="info-text">En fazla 5 tercüman seçebilirsiniz. Seçilenler ana sayfada gösterilir.</p>

    <table class="translator-table">
      <thead>
        <tr>
          <th>Ad</th>
          <th>Üniversite</th>
          <th>Diller</th>
          <th>Deneyim</th>
          <th>Durum</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="translator in translators"
          :key="translator.id"
          :class="{ selected: translator.is_featured }"
        >
          <td data-label="Ad">{{ translator.name }} {{ translator.surname }}</td>
          <td>{{ (translator.university_name && translator.university_department) ? translator.university_name + ' / ' + translator.university_department : '–' }}</td>
          <td>
            {{ Array.isArray(translator.languages) ? translator.languages.join(', ') : translator.languages }}
          </td>
          <td>{{ translator.experience || 'Belirtilmemiş' }}</td>
          <td>
            <button
              @click="toggleFeatured(translator)"
              class="feature-btn"
              :class="{ active: translator.is_featured }"
            >
              {{ translator.is_featured ? 'Kaldır' : 'Öne Çıkar' }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import axios from 'axios'
import { getToken } from '@/utils/auth'

const baseURL = process.env.VUE_APP_API_URL
const translators = ref([])
const token = getToken()

const featuredCount = computed(() =>
  translators.value.filter(t => t.is_featured).length
)

async function fetchTranslators() {
  try {
    const res = await axios.get(`${baseURL}/admin/translators/approved`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    translators.value = res.data
  } catch (err) {
    console.error('Tercümanlar alınamadı:', err)
  }
}

async function toggleFeatured(translator) {
  const isFeatured = Number(translator.is_featured) === 1;
  const updated = isFeatured ? 0 : 1;
  
  if (updated === 1 && featuredCount.value >= 5) {
    alert('En fazla 5 tercüman öne çıkarılabilir.');
    
    return;
  }

  const originalState = translator.is_featured;
  translator.is_featured = updated;

  try {
    const res = await axios.put(
      `${baseURL}/admin/translator/${translator.id}/feature`,
      { is_featured: updated },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    
    await fetchTranslators();
  } catch (err) {
    translator.is_featured = originalState;
    console.error('Güncelleme hatası:', err);
  }
}

onMounted(fetchTranslators)
</script>

<style scoped>
.featured-translators {
  max-width: 900px;
  margin: 80px auto 40px;
  background: rgba(255, 255, 255, 0.07);
  padding: 30px;
  border-radius: 12px;
  backdrop-filter: blur(5px);
}

h2 {
  margin-bottom: 12px;
  color: #fff;
}

.info-text {
  font-size: 14px;
  color: #ddd;
  margin-bottom: 20px;
}

.translator-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.translator-table th,
.translator-table td {
  padding: 12px;
  text-align: left;
  font-size: 14px;
  border-bottom: 1px solid #e0e0e0;
}

.translator-table th {
  background: #f6f6f6;
  color: #333;
}

.translator-table td {
  color: #444;
}

.translator-table tr.selected {
  background-color: #e6f7ff;
}

.feature-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background-color: #4caf50;
  color: white;
  cursor: pointer;
  transition: 0.3s ease;
  font-size: 13px;
}

.feature-btn.active {
  background-color: #ff6666;
}

.feature-btn:not(.active):hover {
  background-color: #45a049;
}

.feature-btn.active:hover {
  background-color: #ff4d4d;
}
@media (max-width: 768px) {
  .featured-translators {
    padding: 20px;
    margin: 40px 16px;
  }

  .translator-table thead {
    display: none; /* başlıkları gizle mobilde */
  }

  .translator-table,
  .translator-table tbody,
  .translator-table tr,
  .translator-table td {
    display: block;
    width: 100%;
  }

  .translator-table tr {
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #fff;
    padding: 10px;
  }

  .translator-table td {
    text-align: right;
    padding-left: 50%;
    position: relative;
    border-bottom: none;
  }

  .translator-table td::before {
    content: attr(data-label);
    position: absolute;
    left: 12px;
    width: 45%;
    white-space: nowrap;
    font-weight: bold;
    text-align: left;
    color: #333;
  }

  .feature-btn {
    width: 100%;
    margin-top: 10px;
  }
}
</style>
